import { Servicio } from "../../servicios/models/servicio.model";
import { BranchModel } from "../../shared/models/branch.model";
import { ContractModel } from "../../shared/models/contract.model";
import { User } from "../../user/models/user.model";
import { QueueAlertInterface } from "../interfaces/queue-alert.interface";
import { TargetPeople, TargetPeopleArray } from "../../target-people/models/target-people.model";
import { QueueAlertFormGroupInterface, QueueAlertFormInterface } from "../interfaces/queue-alert-form.interface";

export class QueueAlert implements QueueAlertInterface {
  _id!: string;
  trigger_people_quantity?: number;
  target_people?: TargetPeopleArray;
  cooldown?: number;
  templete?: string;
  service?: Servicio;
  branch?: BranchModel;
  contract?: ContractModel;
  created_by?: User;
  createdAt?: Date;
  updatedAt?: Date;
  __v?: number;
  constructor(data: QueueAlertInterface) {
    this._id = data._id || '';
    this.trigger_people_quantity = data.trigger_people_quantity || 0;
    this.target_people = !!data.target_people ? TargetPeople.fromJsonArray(data.target_people) : [];
    this.service = data.service ? new Servicio(data.service) : undefined;
    this.cooldown = data.cooldown || 0;
    this.templete = data.templete || '';
    this.created_by = data.created_by ? new User(data.created_by) : undefined;
    this.contract = data.contract
    this.branch = data.branch
    this.createdAt = data.createdAt || new Date();
    this.updatedAt = data.updatedAt || new Date();
    this.__v = data.__v || 0;
  }

  static fromJson(data: QueueAlertInterface): QueueAlert {
    return new QueueAlert(data);
  }
  static fromJsonArray(data: QueueAlertArray): QueueAlertArray {
    return data.map((item) => new QueueAlert(item));
  }

  static fromForm(data: QueueAlertFormInterface, id?: string) {
    return new QueueAlert({
      _id: id ? id : '',
      trigger_people_quantity: data.trigger_people_quantity ? data.trigger_people_quantity : undefined,
      target_people: data.target_people ? TargetPeople.fromJsonArray(data.target_people) : undefined,
      service: data.service ? new Servicio(data.service) : undefined,
      cooldown: data.cooldown ? data.cooldown : undefined,
      templete: data.templete ? data.templete : undefined,
      contract: data.contract ? data.contract : undefined,
      branch: data.branch ? data.branch : undefined,
    });
  }

  get formattedCreatedAt(): string {
    return this.createdAt? new Date(this.createdAt).toISOString().split('T')[0] : 'Fecha de creación desconocida';
  }
  get formattedContractName(): string {
    return this.contract?.name ? this.contract.name : 'Contrato sin nombre';
  }
  get formattedBranchName(): string {
    return this.branch?.name || 'No hay sucursal';
  }
  get formattedCreatedBy(): string {
    return this.created_by?.username || 'Usuario sin nombre';
  }
  get formattedServiceName(): string {
    return this.service?.formattedName || 'Servicio sin nombre';
  }
  get formattedTargetPeople(): string {
    return this.target_people?.map((tp) => tp.contact).join(', ') || 'No hay personas objetivo';
  }
  get formattedTargetPeopleLength(): string {
    return this.target_people ? `${this.target_people.length} personas para notificar` : 'No hay personas objetivo';
  }
  get formattedCooldown(): string {
    return this.cooldown ? `${this.cooldown} minutos` : 'Sin cooldown';
  }
  get formattedTemplete(): string {
    return this.templete || 'Sin plantilla de mensaje';
  }
  get formattedTriggerPeopleQuantity(): string {
    return this.trigger_people_quantity ? `${this.trigger_people_quantity} personas en espera para activar` : 'Sin cantidad de personas para activar';
  }
}

export type QueueAlertArray = QueueAlert[];
